import src from "IMAGE";
export default { src, width: 256, height: 260, blurWidth: 0, blurHeight: 0};
